import React from 'react';
import './css/home.css';
import HomeScreen from './Screens/HomeScreen';

function App() {
  return <HomeScreen />;
}

export default App;
